"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7013],{

/***/ 11131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ox": function() { return /* binding */ getCountries; },
/* harmony export */   "cl": function() { return /* binding */ getNationalities; },
/* harmony export */   "Bf": function() { return /* binding */ propertyRemovedReasons; },
/* harmony export */   "Xp": function() { return /* binding */ propertyReviewReasons; },
/* harmony export */   "ag": function() { return /* binding */ crmSites; },
/* harmony export */   "Cj": function() { return /* binding */ nationalPortals; },
/* harmony export */   "hJ": function() { return /* binding */ internationalPortals; },
/* harmony export */   "l$": function() { return /* binding */ aggregatorPortals; },
/* harmony export */   "bh": function() { return /* binding */ mlsPortals; },
/* harmony export */   "gF": function() { return /* binding */ partnerPortals; },
/* harmony export */   "FO": function() { return /* binding */ getScoringTraits; },
/* harmony export */   "sC": function() { return /* binding */ getValidYalsAmenityNames; }
/* harmony export */ });
/* unused harmony exports getReasons, getBrokerTypes, planCodes */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var getCountries = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.countries || [];
});
var getNationalities = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.nationalities || [];
});
var getReasons = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.reasons || [];
});
var propertyRemovedReasons = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(getReasons, function(reasons) {
    return reasons.filter(function(reason) {
        return reason.type === 'PROPERTY_REMOVED';
    });
});
var propertyReviewReasons = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(getReasons, function(reasons) {
    return reasons.filter(function(reason) {
        return reason.type === 'REVIEW';
    });
});
var crmSites = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.sites || [];
});
var nationalPortals = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(crmSites, function(portals) {
    return portals.filter(function(portal) {
        return portal.visibility === 'NATIONAL' && portal.category !== 'AGGREGATOR' && portal.category !== 'MLS' && portal.category !== 'PARTNER';
    });
});
var internationalPortals = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(crmSites, function(portals) {
    return portals.filter(function(portal) {
        return portal.visibility === 'INTERNATIONAL' && portal.category !== 'AGGREGATOR' && portal.category !== 'MLS' && portal.category !== 'PARTNER';
    });
});
var aggregatorPortals = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(crmSites, function(portals) {
    return portals.filter(function(portal) {
        return portal.category === 'AGGREGATOR';
    });
});
var mlsPortals = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(crmSites, function(portals) {
    return portals.filter(function(portal) {
        return portal.category === 'MLS';
    });
});
var partnerPortals = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(crmSites, function(portals) {
    return portals.filter(function(portal) {
        return portal.category === 'PARTNER';
    });
});
var getScoringTraits = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.traits || [];
});
var getBrokerTypes = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.brokerTypes || [];
});
var planCodes = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    return config.planCodes || [];
});
var getValidYalsAmenityNames = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(function(state) {
    return state.app.config;
}, function(config) {
    var yalsMappings = config.yalsMappings || {
        amenities: {}
    };
    return Object.keys(yalsMappings.amenities);
});



/***/ }),

/***/ 30471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hM": function() { return /* binding */ sendMessageWhatsapp; },
/* harmony export */   "g7": function() { return /* binding */ mobilCallPhone; },
/* harmony export */   "Cz": function() { return /* binding */ sendEmail; }
/* harmony export */ });
/* unused harmony exports makeAnAnchor, isMobileDebice */
/* harmony import */ var services_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58800);

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * sendMessageWhatsapp - send a message through the whatsapp app
 * @param {string} telephone
 * @param {string} message
 */ var sendMessageWhatsapp = function(telephone, message) {
    var whatsappMessage = encodeURIComponent(message);
    var url = "https://wa.me/".concat((0,services_number__WEBPACK_IMPORTED_MODULE_0__/* .onlyNumbers */ .wp)(telephone), "?text=").concat(whatsappMessage);
    makeAnAnchor(url, openExternalLinkInDesktop());
};
/**
 * mobilCallPhone - start the mobile app to call the phone number
 * @param {string} telephone
 */ var mobilCallPhone = function(telephone) {
    var url = "tel:".concat(telephone);
    makeAnAnchor(url);
};
/**
 * sendEmail
 * @param {String} email
 * @param {Object} config
 */ var sendEmail = function(email) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var url = "mailto:".concat(email, "?Subject=").concat(config.subject || '', "&&body=").concat(config.message || config.body || '');
    makeAnAnchor(url, openExternalLinkInDesktop());
};
var makeAnAnchor = function(url) {
    var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var element = document.createElement('a');
    attributes.forEach(function(att) {
        var ref = _slicedToArray(Object.keys(att), 1), key = ref[0];
        element.setAttribute(key, att[key]);
    });
    element.setAttribute('href', url);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};
var openExternalLinkInDesktop = function() {
    var attributes = [];
    if (!isMobileDebice()) {
        attributes.push({
            target: '_blank'
        });
    }
    return attributes;
};
var isMobileDebice = function() {
    // Solution from https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
    var currentAgent = navigator.userAgent || navigator.vendor || window.opera;
    var firstRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
    var secondRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
    return firstRegex.test(currentAgent) || secondRegex.test(currentAgent.substr(0, 4));
};


/***/ }),

/***/ 47886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ transformBackendErrors; }
/* harmony export */ });
// Map backend field names (snake_case) to form field names (camelCase)
var mapFieldName = function(field) {
    var mapping = {
        'old_password': 'oldPassword',
        'new_password': 'newPassword',
        'confirm_password': 'confirmPassword'
    };
    return mapping[field] || field;
};
// Translate backend error messages to Spanish
var translateErrorMessage = function(message) {
    var translations = {
        'Your password is not valid.': 'Tu contrase\xf1a actual es incorrecta.',
        'Cannot reuse one of your last 3 passwords.': 'No puedes reutilizar una de tus \xfaltimas 3 contrase\xf1as.',
        'Password must contain at least 1 digit, 1 lowercase, 1 uppercase, 1 special character, and be 8-20 characters.': 'La contrase\xf1a debe contener al menos 1 d\xedgito, 1 min\xfascula, 1 may\xfascula, 1 car\xe1cter especial, y tener entre 8-20 caracteres.',
        'Password should not contain mailbox, mailbox_domain, first_name, second_name, last_name, second_last_name.': 'La contrase\xf1a no debe contener tu nombre, apellido o correo electr\xf3nico.'
    };
    return translations[message] || message;
};
// Transform backend errors to redux-form format
var transformBackendErrors = function(error) {
    if (!error || typeof error !== 'object') return {};
    var formErrors = {};
    Object.keys(error).forEach(function(field) {
        var mappedField = mapFieldName(field);
        var messages = error[field];
        var rawMessage = Array.isArray(messages) ? messages[0] : messages;
        formErrors[mappedField] = translateErrorMessage(rawMessage);
    });
    return formErrors;
};


/***/ }),

/***/ 96420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ze": function() { return /* binding */ validatorUser; },
/* harmony export */   "h5": function() { return /* binding */ profileNewPasswordValidator; },
/* harmony export */   "KX": function() { return /* binding */ mailboxNewPasswordValidator; },
/* harmony export */   "st": function() { return /* binding */ ValidatorFiscalData; },
/* harmony export */   "Y1": function() { return /* binding */ validatorSocialNetworks; }
/* harmony export */ });
/* unused harmony exports validatorNewUser, validatorPassword, unifiedPasswordValidator, updateEmailValidator */
/* harmony import */ var services_validators__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82257);
/* harmony import */ var react_phone_number_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58185);
/* harmony import */ var _profileText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27079);



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var validatorUser = function(values) {
    var errors = {};
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.firstName)) {
        errors.firstName = 'Nombre requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.lastName)) {
        errors.lastName = 'Apellido requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.telephone)) {
        errors.telephone = 'Tel\xe9fono requerido';
    } else if (!(0,react_phone_number_input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(values.telephone)) {
        errors.telephone = 'Tel\xe9fono inv\xe1lido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.about) || !(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .requiredRichText */ .xf)(values.about)) {
        errors.about = 'Biograf\xeda requerida';
    } else {
        errors.about = (0,_profileText__WEBPACK_IMPORTED_MODULE_1__/* .validateProfileText */ .hV)(values.about, _profileText__WEBPACK_IMPORTED_MODULE_1__/* .PROFILE_TEXT_LIMITS.about */ .g7.about);
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.birthday)) {
        errors.birthday = 'Fecha de nacimiento requerida';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.experience) || !(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .requiredRichText */ .xf)(values.experience)) {
        errors.experience = 'Experiencia requerida';
    } else {
        errors.experience = (0,_profileText__WEBPACK_IMPORTED_MODULE_1__/* .validateProfileText */ .hV)(values.experience, _profileText__WEBPACK_IMPORTED_MODULE_1__/* .PROFILE_TEXT_LIMITS.experience */ .g7.experience);
    }
    if (!!values.video && !(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validUrl */ .DN)(values.video)) {
        errors.video = 'URL inv\xe1lida';
    }
    return errors;
};
var validatorNewUser = function(values) {
    var errors = {};
    if (!required(values.firstName)) {
        errors.firstName = 'Nombre requerido';
    }
    if (!required(values.lastName)) {
        errors.lastName = 'Apellido requerido';
    }
    if (!required(values.birthday)) {
        errors.birthday = 'Fecha de nacimiento requerida';
    }
    if (!required(values.brokerType)) {
        errors.about = 'Requerido';
    }
    if (!required(values.country)) {
        errors.country = 'Pa\xeds requerido';
    }
    if (!required(values.curp)) {
        errors.curp = 'CURP Requerida';
    } else if (!validCurp(values.curp)) {
        errors.curp = "CURP inv\xe1lida";
    }
    if (values.isFullService) {
        if (!required(values.optionSubdomain)) {
            errors.optionSubdomain = 'Seleccione un subdominio';
        } else if (values.optionSubdomain === 'CUSTOM') {
            if (!required(values.customSubdomain)) {
                errors.customSubdomain = 'Especifique un subdominio';
            }
            if (!validSubdomain(values.customSubdomain)) {
                errors.customSubdomain = 'El subdominio no est\xe1 permitido';
            }
            if (!required(values.subdomain)) {
                errors.subdomain = 'Verifique la disponibilidad del subdominio';
            }
        }
    }
    return errors;
};
var validatorPassword = function(values) {
    var errors = {};
    if (!required(values.oldPassword)) {
        errors.oldPassword = 'Password anterior requerido';
    }
    if (!required(values.newPassword)) {
        errors.newPassword = 'Nuevo password requerido';
    }
    return errors;
};
// Generate last 10 years dynamically
var currentYear = new Date().getFullYear();
var RECENT_YEARS = Array.from({
    length: 15
}, function(_, i) {
    return String(currentYear - 9 + i);
});
var STATIC_DISALLOWED_WORDS = [
    'iad',
    'neximo',
    'mexico',
    'karim',
    'nico',
    // Common weak passwords
    'password',
    'contrase\xf1a',
    'hola',
    'qwerty',
    'admin',
    'welcome'
].concat(// Dynamic years (last 10 years)
_toConsumableArray(RECENT_YEARS));
/**
 * Unified password validator for both profile and mailbox passwords
 * @param {object} values
 * @param {string} values.newPassword
 * @param {string} values.confirmPassword
 * @param {object} props
 * @param {object} [props.userProfile]
 * @returns {{newPassword?: string, confirmPassword?: string}}
 */ var unifiedPasswordValidator = function(values) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var errors = {};
    var userProfile = props.userProfile;
    // Required check
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.newPassword)) {
        errors.newPassword = 'Nueva contrase\xf1a requerida';
    } else if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validMailboxPassword */ .q3)(values.newPassword)) {
        // Regex validation (10+ chars, upper, lower, number, special)
        errors.newPassword = 'La contrase\xf1a no cumple con los requisitos';
    } else if ((0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .hasSequentialDigits */ .oh)(values.newPassword)) {
        // Sequential digits check
        errors.newPassword = 'La contrase\xf1a no puede contener secuencias num\xe9ricas (ej: 123, 321)';
    }
    // Disallowed words check
    if (!errors.newPassword && values.newPassword) {
        var disallowedWords = _toConsumableArray(STATIC_DISALLOWED_WORDS);
        if (userProfile) {
            var firstName = userProfile.firstName, secondName = userProfile.secondName, lastName = userProfile.lastName, secondLastName = userProfile.secondLastName, mailbox = userProfile.mailbox, mailboxDomain = userProfile.mailboxDomain;
            disallowedWords.push(firstName, secondName, lastName, secondLastName, mailbox, mailboxDomain);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = disallowedWords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var word = _step.value;
                if (!word) continue;
                if (values.newPassword.toLowerCase().includes(word.toLowerCase())) {
                    if (STATIC_DISALLOWED_WORDS.includes(word)) {
                        errors.newPassword = "La contrase\xf1a no puede contener la palabra reservada \"".concat(word, "\"");
                    } else {
                        errors.newPassword = 'La contrase\xf1a no puede contener tu nombre, apellido o correo electr\xf3nico';
                    }
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    // Confirm password check
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.confirmPassword)) {
        errors.confirmPassword = 'Confirmar contrase\xf1a requerida';
    } else if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = 'Las contrase\xf1as no coinciden';
    }
    return errors;
};
// Aliases for backward compatibility
var profileNewPasswordValidator = unifiedPasswordValidator;
var mailboxNewPasswordValidator = unifiedPasswordValidator;
var ValidatorFiscalData = function(values) {
    var errors = {};
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.ine)) {
        errors.ine = 'Campo requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.curp)) {
        errors.curp = 'CURP requerida';
    } else if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validCurp */ .gi)(values.curp)) {
        errors.curp = "CURP inv\xe1lida";
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.bank)) {
        errors.bank = 'Campo requerido';
    }
    if (!(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .required */ .C1)(values.bankAccount)) {
        errors.bankAccount = 'Campo requerido';
    }
    if (values.bankAccount && !(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .minLength */ .Ei)(values.bankAccount, 18)) {
        errors.bankAccount = 'La CLABE debe ser de 18 d\xedgitos';
    }
    return errors;
};
var validatorSocialNetworks = function(values) {
    var errors = {};
    if (values.socialnetworks) {
        var socialsArrayErrors = [];
        values.socialnetworks.forEach(function(item, index) {
            if (item.url && !(0,services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validUrl */ .DN)(item.url)) {
                socialsArrayErrors[index] = {
                    url: 'Url inv\xe1lida'
                };
            }
        });
        if (socialsArrayErrors.length) {
            errors.socialnetworks = socialsArrayErrors;
        }
    }
    return errors;
};
var updateEmailValidator = function(values) {
    var errors = {};
    if (!values.emailUsername) {
        errors.emailUsername = 'Este campo es requerido';
    } else if (values.emailUsername.length < 3) {
        errors.emailUsername = 'El email debe tener al menos 3 caracteres';
    } else if (!/^[a-zA-Z0-9._-]+$/.test(values.emailUsername)) {
        errors.emailUsername = 'Solo se permiten letras, n\xfameros, puntos, guiones y guiones bajos';
    }
    if (!values.emailDomain) {
        errors.emailDomain = 'El dominio es requerido';
    }
    return errors;
};


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var controls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16389);
/* harmony import */ var flexbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91584);
/* harmony import */ var flexbox__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(flexbox__WEBPACK_IMPORTED_MODULE_3__);





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ConfirmAction = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ConfirmAction, Component1);
    var _super = _createSuper(ConfirmAction);
    function ConfirmAction() {
        _classCallCheck(this, ConfirmAction);
        return _super.apply(this, arguments);
    }
    _createClass(ConfirmAction, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, message = _props.message, children = _props.children, onConfirm = _props.onConfirm, onCancel = _props.onCancel, loading = _props.loading, _confirmButtonLabel = _props.confirmButtonLabel, confirmButtonLabel = _confirmButtonLabel === void 0 ? "Aceptar" : _confirmButtonLabel, _cancelButtonLabel = _props.cancelButtonLabel, cancelButtonLabel = _cancelButtonLabel === void 0 ? "Cancelar" : _cancelButtonLabel, disabledConfirm = _props.disabledConfirm, modalProps = _objectWithoutProperties(_props, [
                    "message",
                    "children",
                    "onConfirm",
                    "onCancel",
                    "loading",
                    "confirmButtonLabel",
                    "cancelButtonLabel",
                    "disabledConfirm"
                ]);
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(controls__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, _objectSpread({}, modalProps, {
                    onClose: onCancel,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            textAlign: 'center',
                            padding: '2rem'
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                                children: message
                            }),
                            children,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(flexbox__WEBPACK_IMPORTED_MODULE_3__.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(flexbox__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                        xs: 6,
                                        sm: 4,
                                        smOffset: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(controls__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                            color: "primary",
                                            fullWidth: true,
                                            outline: true,
                                            onClick: onCancel,
                                            children: cancelButtonLabel
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(flexbox__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                        xs: 6,
                                        sm: 4,
                                        smOffset: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(controls__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                            color: "primary",
                                            fullWidth: true,
                                            onClick: onConfirm,
                                            loading: loading,
                                            disabled: disabledConfirm,
                                            children: confirmButtonLabel
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })));
            }
        }
    ]);
    return ConfirmAction;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
_defineProperty(ConfirmAction, "propTypes", {
    message: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().any.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().any.isRequired),
    onConfirm: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
    onCancel: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
    loading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
    disabledConfirm: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)
});
_defineProperty(ConfirmAction, "defaultProps", {
    message: '',
    loading: false
});
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmAction);


/***/ }),

/***/ 82041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modals_ModalConfirm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
// EXTERNAL MODULE: ./controls/utils/react-flexbox-grid.js
var react_flexbox_grid = __webpack_require__(91584);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
;// CONCATENATED MODULE: ./components/Modals/ModalConfirm/styles.js

var _defaultExport = new String(/*#__PURE__*/ "header.jsx-f0e46d8c56c2b5af{font-size:1.2rem;\nfont-weight:".concat(theme/* fontWeights.semiBold */.vC.semiBold, "}\n.container.jsx-f0e46d8c56c2b5af{text-align:center;\npadding:2rem}\n@media screen and (max-width:992px) {.container.jsx-f0e46d8c56c2b5af{padding:1.5rem 1rem 2rem}}"));
_defaultExport.__hash = "f0e46d8c56c2b5af";
/* harmony default export */ var styles = (_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/ModalConfirm/index.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ModalConfirm = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ModalConfirm, Component1);
    var _super = _createSuper(ModalConfirm);
    function ModalConfirm() {
        _classCallCheck(this, ModalConfirm);
        return _super.apply(this, arguments);
    }
    _createClass(ModalConfirm, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, message = _props.message, children = _props.children, buttonConfirmLabel = _props.buttonConfirmLabel, buttonRejectLabel = _props.buttonRejectLabel, onConfirm = _props.onConfirm, onCancel = _props.onCancel, loading = _props.loading, disabledConfirm = _props.disabledConfirm, showRejectButton = _props.showRejectButton, okButtonProps = _props.okButtonProps, _styleButtonsType = _props.styleButtonsType, styleButtonsType = _styleButtonsType === void 0 ? "rounded" : _styleButtonsType, modalProps = _objectWithoutProperties(_props, [
                    "message",
                    "children",
                    "buttonConfirmLabel",
                    "buttonRejectLabel",
                    "onConfirm",
                    "onCancel",
                    "loading",
                    "disabledConfirm",
                    "showRejectButton",
                    "okButtonProps",
                    "styleButtonsType"
                ]);
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, _objectSpread({}, modalProps, {
                    onClose: onCancel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(styles.__hash) + " " + "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                    className: "jsx-".concat(styles.__hash),
                                    children: message
                                }),
                                children,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                    className: "jsx-".concat(styles.__hash)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                                    children: [
                                        showRejectButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                            xs: 6,
                                            sm: 4,
                                            smOffset: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                fullWidth: true,
                                                outline: true,
                                                color: "secondary",
                                                styleType: styleButtonsType,
                                                onClick: onCancel,
                                                children: buttonRejectLabel
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                            xs: showRejectButton ? 6 : 12,
                                            sm: showRejectButton ? 4 : 12,
                                            smOffset: showRejectButton ? 2 : 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, _objectSpread({
                                                fullWidth: true,
                                                outline: true,
                                                color: "success",
                                                styleType: styleButtonsType,
                                                onClick: onConfirm,
                                                loading: loading,
                                                disabled: disabledConfirm
                                            }, okButtonProps, {
                                                children: buttonConfirmLabel
                                            }))
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles.__hash,
                            children: styles
                        })
                    ]
                })));
            }
        }
    ]);
    return ModalConfirm;
}(react.Component);
_defineProperty(ModalConfirm, "propTypes", {
    message: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).any.isRequired,
    buttonConfirmLabel: (prop_types_default()).string.isRequired,
    onConfirm: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired,
    loading: (prop_types_default()).bool.isRequired,
    disabledConfirm: (prop_types_default()).bool
});
_defineProperty(ModalConfirm, "defaultProps", {
    message: '',
    loading: false,
    showRejectButton: true,
    buttonConfirmLabel: 'Aceptar',
    buttonRejectLabel: 'Cancelar'
});
/* harmony default export */ var Modals_ModalConfirm = (ModalConfirm);


/***/ }),

/***/ 40089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modals_PasswordAuditModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js
var redux_form_es = __webpack_require__(72772);
// EXTERNAL MODULE: ./node_modules/redux-form/es/Field.js + 8 modules
var Field = __webpack_require__(44515);
// EXTERNAL MODULE: ./node_modules/redux-form/es/formValueSelector.js + 1 modules
var formValueSelector = __webpack_require__(31767);
// EXTERNAL MODULE: ./node_modules/redux-form/es/reduxForm.js + 13 modules
var reduxForm = __webpack_require__(78938);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./controls/Input/index.js
var Input = __webpack_require__(24493);
// EXTERNAL MODULE: ./controls/utils/react-flexbox-grid.js
var react_flexbox_grid = __webpack_require__(91584);
// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
// EXTERNAL MODULE: ./app/services/index.js + 2 modules
var services = __webpack_require__(64380);
// EXTERNAL MODULE: ./app/reducers/AlertRedux.js
var AlertRedux = __webpack_require__(62961);
// EXTERNAL MODULE: ./app/reducers/AuditRedux.js
var AuditRedux = __webpack_require__(75746);
// EXTERNAL MODULE: ./app/validators/profile.js
var profile = __webpack_require__(96420);
// EXTERNAL MODULE: ./app/selectors/user.js
var user = __webpack_require__(53584);
// EXTERNAL MODULE: ./app/services/passwordErrors.js
var passwordErrors = __webpack_require__(47886);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
;// CONCATENATED MODULE: ./components/Modals/PasswordAuditModal/styles.js

var _defaultExport = new String(".content.jsx-be8de35503f87c86{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\npadding:1.5rem;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmax-width:500px;\nmargin:0 auto}\n.password-type-badge.jsx-be8de35503f87c86{display:-webkit-inline-box;\ndisplay:-webkit-inline-flex;\ndisplay:-ms-inline-flexbox;\ndisplay:inline-flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:0.5rem;\npadding:0.5rem 1rem;\nborder-radius:20px;\n".concat((0,theme/* getFont */.qT)('semiBold', 'small'), ";\nletter-spacing:0.5px;\nmargin-bottom:1rem}\n.password-type-badge.plataforma.jsx-be8de35503f87c86{background-color:").concat(theme/* colors.primaryLight */.O9.primaryLight || '#e3f2fd', ";\ncolor:").concat(theme/* colors.primary */.O9.primary, "}\n.password-type-badge.mailbox.jsx-be8de35503f87c86{background-color:").concat(theme/* colors.secondaryLight */.O9.secondaryLight || '#fff3e0', ";\ncolor:").concat(theme/* colors.secondary */.O9.secondary || '#ff9800', "}\n.password-type-badge.jsx-be8de35503f87c86>i{font-size:1rem}\nh3.jsx-be8de35503f87c86{").concat((0,theme/* getFont */.qT)('semiBold', 'h4'), ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-bottom:0.5rem;\ntext-align:center}\nh3.jsx-be8de35503f87c86>i{color:").concat(theme/* colors.primary */.O9.primary, ";\nmargin-right:0.5rem}\n.subtitle.jsx-be8de35503f87c86{").concat((0,theme/* getFont */.qT)('regular', 'p'), ";\ncolor:").concat(theme/* colors.gray */.O9.gray, ";\ntext-align:center;\nline-height:1.5}\n.subtitle.platform-message.jsx-be8de35503f87c86{margin-bottom:1.5rem}\n.subtitle.jsx-be8de35503f87c86 strong{color:").concat(theme/* colors.text */.O9.text, "}\n.mailbox-warning.jsx-be8de35503f87c86{display:block;\nmargin:0rem;\npadding:0.5rem;\nbackground-color:").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.warningLow */.O9.warningLow, 0.2), ";\ncolor:").concat(theme/* colors.secondary */.O9.secondary, ";\nborder:1px solid ").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.warningLow */.O9.warningLow, 0.2), ";\nborder-radius:8px;\nfont-size:0.875rem;\nline-height:1.4}\n.form-container.jsx-be8de35503f87c86{width:100%}\n.form-container.jsx-be8de35503f87c86 .password-profile, .form-container.jsx-be8de35503f87c86 .password-mailbox{width:100%}\n.form-container.jsx-be8de35503f87c86 form{width:100%}\n.form-container.jsx-be8de35503f87c86 .form-input-margin{margin-bottom:1rem}\n.form-container.jsx-be8de35503f87c86 button[type=\"submit\"]{margin-top:0.5rem}\n.error-message.jsx-be8de35503f87c86{color:").concat(theme/* colors.error */.O9.error, ";\n").concat((0,theme/* getFont */.qT)('regular', 'small'), ";\ntext-align:center;\nmargin-top:0.5rem}\n.success-message.jsx-be8de35503f87c86{color:").concat(theme/* colors.success */.O9.success, ";\n").concat((0,theme/* getFont */.qT)('regular', 'small'), ";\ntext-align:center;\nmargin-top:0.5rem}\n@media (max-width:768px) {.title.jsx-be8de35503f87c86{font-size:1.25rem}}"));
_defaultExport.__hash = "be8de35503f87c86";
/* harmony default export */ var styles = (_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/PasswordAuditModal/index.js
















var PlataformaPasswordForm = function(param) {
    var handleSubmit = param.handleSubmit, invalid = param.invalid, loading = param.loading, newPassword = param.newPassword;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Col, {
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                            name: "newPassword",
                            id: "auditNewPassword",
                            type: "password",
                            autoComplete: "new-password",
                            className: "form-input-margin",
                            component: Input/* InputForm */.M5,
                            placeholder: "Nueva contrase\xf1a",
                            disabled: loading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* PasswordStrengthIndicator */.oe, {
                            password: newPassword || '',
                            show: Boolean(newPassword)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        name: "confirmPassword",
                        id: "auditConfirmPassword",
                        type: "password",
                        autoComplete: "new-password",
                        className: "form-input-margin",
                        component: Input/* InputForm */.M5,
                        placeholder: "Confirmar contrase\xf1a",
                        disabled: loading
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                        type: "submit",
                        disabled: invalid || loading,
                        color: "primary",
                        fullWidth: true,
                        loading: loading,
                        children: "Cambiar contrase\xf1a"
                    })
                })
            })
        ]
    });
};
var plataformaSelector = (0,formValueSelector/* default */.Z)('auditPlataformaPassword');
var PlataformaPasswordReduxForm = (0,es/* connect */.$j)(function(state) {
    return {
        newPassword: plataformaSelector(state, 'newPassword')
    };
})((0,reduxForm/* default */.Z)({
    form: 'auditPlataformaPassword',
    validate: profile/* profileNewPasswordValidator */.h5
})(PlataformaPasswordForm));
var MailboxPasswordForm = function(param) {
    var handleSubmit = param.handleSubmit, invalid = param.invalid, loading = param.loading, newPassword = param.newPassword;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Col, {
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                            name: "newPassword",
                            id: "auditMailboxNewPassword",
                            type: "password",
                            autoComplete: "new-password",
                            className: "form-input-margin",
                            component: Input/* InputForm */.M5,
                            placeholder: "Nueva contrase\xf1a",
                            disabled: loading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* PasswordStrengthIndicator */.oe, {
                            password: newPassword || '',
                            show: Boolean(newPassword)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                        name: "confirmPassword",
                        id: "auditMailboxConfirmPassword",
                        type: "password",
                        autoComplete: "new-password",
                        className: "form-input-margin",
                        component: Input/* InputForm */.M5,
                        placeholder: "Confirmar contrase\xf1a",
                        disabled: loading
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                        type: "submit",
                        disabled: invalid || loading,
                        color: "primary",
                        fullWidth: true,
                        loading: loading,
                        children: "Cambiar contrase\xf1a"
                    })
                })
            })
        ]
    });
};
var mailboxSelector = (0,formValueSelector/* default */.Z)('auditMailboxPassword');
var MailboxPasswordReduxForm = (0,es/* connect */.$j)(function(state) {
    return {
        newPassword: mailboxSelector(state, 'newPassword')
    };
})((0,reduxForm/* default */.Z)({
    form: 'auditMailboxPassword',
    validate: profile/* mailboxNewPasswordValidator */.KX
})(MailboxPasswordForm));
var PasswordAuditModal = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var changeDashboardPass = (0,es/* useSelector */.v9)(function(state) {
        return state.audit.changeDashboardPass;
    });
    var changeMailboxPass = (0,es/* useSelector */.v9)(function(state) {
        return state.audit.changeMailboxPass;
    });
    var updateDashboardPassword = (0,es/* useSelector */.v9)(function(state) {
        return services/* store.updatePassword */.h.updatePassword('user').selector(state);
    });
    var updateMailboxPassword = (0,es/* useSelector */.v9)(function(state) {
        return services/* store.updateMailboxPassword */.h.updateMailboxPassword('user').selector(state);
    });
    var userProfile = (0,es/* useSelector */.v9)(user/* userSelector */.np);
    var prevDashboardLoading = (0,react.useRef)(false);
    var prevMailboxLoading = (0,react.useRef)(false);
    var showModal = changeDashboardPass || changeMailboxPass;
    var showPlataformaForm = changeDashboardPass;
    var showMailboxForm = !changeDashboardPass && changeMailboxPass;
    // Build user's full email from profile
    var userEmail = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.mailbox) && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.mailboxDomain) ? "".concat(userProfile.mailbox, "@").concat(userProfile.mailboxDomain) : null;
    var userName = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.firstName) || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userFullName) || '';
    (0,react.useEffect)(function() {
        if (prevDashboardLoading.current && updateDashboardPassword.finished && !updateDashboardPassword.error && showModal) {
            dispatch(AlertRedux/* AlertActionCreators.success */.$w.success({
                message: 'Contrase\xf1a de Plataforma iad M\xe9xico actualizada correctamente'
            }));
            dispatch(AuditRedux/* AuditActionCreators.clearDashboardPassRequirement */.WL.clearDashboardPassRequirement());
            dispatch((0,redux_form_es/* reset */.mc)('auditPlataformaPassword'));
            dispatch(AuditRedux/* AuditActionCreators.refreshPasswordRequirementsRequest */.WL.refreshPasswordRequirementsRequest());
        } else if (prevDashboardLoading.current && updateDashboardPassword.error) {
            var formErrors = (0,passwordErrors/* transformBackendErrors */.h)(updateDashboardPassword.error);
            if (Object.keys(formErrors).length > 0) {
                dispatch((0,redux_form_es/* stopSubmit */.GK)('auditPlataformaPassword', formErrors));
            }
        }
        prevDashboardLoading.current = updateDashboardPassword.loading;
    }, [
        updateDashboardPassword.loading,
        updateDashboardPassword.finished,
        updateDashboardPassword.error,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (prevMailboxLoading.current && updateMailboxPassword.finished && !updateMailboxPassword.error) {
            dispatch(AlertRedux/* AlertActionCreators.success */.$w.success({
                message: 'Contrase\xf1a del correo actualizada correctamente'
            }));
            dispatch(AuditRedux/* AuditActionCreators.clearMailboxPassRequirement */.WL.clearMailboxPassRequirement());
            dispatch((0,redux_form_es/* reset */.mc)('auditMailboxPassword'));
            dispatch(AuditRedux/* AuditActionCreators.refreshPasswordRequirementsRequest */.WL.refreshPasswordRequirementsRequest());
        } else if (prevMailboxLoading.current && updateMailboxPassword.error) {
            var formErrors = (0,passwordErrors/* transformBackendErrors */.h)(updateMailboxPassword.error);
            if (Object.keys(formErrors).length > 0) {
                dispatch((0,redux_form_es/* stopSubmit */.GK)('auditMailboxPassword', formErrors));
            }
        }
        prevMailboxLoading.current = updateMailboxPassword.loading;
    }, [
        updateMailboxPassword.loading,
        updateMailboxPassword.finished,
        updateMailboxPassword.error,
        dispatch
    ]);
    var handlePlataformaPasswordSubmit = function(values) {
        dispatch(services/* store.updatePassword */.h.updatePassword('user').action(values));
    };
    var handleMailboxPasswordSubmit = function(values) {
        dispatch(services/* store.updateMailboxPassword */.h.updateMailboxPassword('user').action(values));
    };
    if (!showModal) {
        return null;
    }
    // Build personalized mailbox message
    var getMailboxMessage = function() {
        if (userName && userEmail) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: userName
                    }),
                    ", por pol\xedticas de seguridad debes actualizar la contrase\xf1a de tu correo electr\xf3nico ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: userEmail
                    })
                ]
            }));
        }
        if (userEmail) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Por pol\xedticas de seguridad, debes actualizar la contrase\xf1a de tu correo electr\xf3nico ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: userEmail
                    })
                ]
            }));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Por pol\xedticas de seguridad, debes actualizar la contrase\xf1a de tu correo electr\xf3nico."
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, {
        isOpen: showModal,
        showCloseButton: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "jsx-".concat(styles.__hash) + " " + "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles.__hash) + " " + "password-type-badge ".concat(showPlataformaForm ? 'plataforma' : 'mailbox'),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                icon: showPlataformaForm ? 'ios-apps' : 'ios-mail'
                            }),
                            showPlataformaForm ? 'PLATAFORMA iad M\xe9xico' : 'CORREO'
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "jsx-".concat(styles.__hash) + " " + 'title',
                        children: showPlataformaForm ? 'Cambiar contrase\xf1a de Plataforma iad M\xe9xico' : 'Cambiar contrase\xf1a de tu Correo'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-".concat(styles.__hash) + " " + (classnames_default()("subtitle", {
                            'platform-message': showPlataformaForm
                        }) || ""),
                        children: showPlataformaForm ? 'Por pol\xedticas de seguridad, debes actualizar la contrase\xf1a que usas para acceder a la Plataforma iad M\xe9xico.' : getMailboxMessage()
                    }),
                    !showPlataformaForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-".concat(styles.__hash) + " " + 'mailbox-warning',
                        children: "Recuerda que debes a\xf1adir tu nuevo pass a cualquier dispositivo que hayas conectado y si lo tienes integrado al CRM tambi\xe9n debes de actualizarlo ah\xed."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles.__hash) + " " + "form-container",
                        children: [
                            showPlataformaForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlataformaPasswordReduxForm, {
                                onSubmit: handlePlataformaPasswordSubmit,
                                loading: updateDashboardPassword.loading
                            }),
                            showMailboxForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(MailboxPasswordReduxForm, {
                                onSubmit: handleMailboxPasswordSubmit,
                                loading: updateMailboxPassword.loading,
                                userProfile: userProfile
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: styles.__hash,
                children: styles
            })
        ]
    }));
};
/* harmony default export */ var Modals_PasswordAuditModal = (PasswordAuditModal);


/***/ }),

/***/ 37952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gy": function() { return /* reexport */ Modals_AddNote; },
  "Ur": function() { return /* reexport */ ConfirmAction/* default */.Z; },
  "WZ": function() { return /* reexport */ ModalConfirm/* default */.Z; },
  "rQ": function() { return /* reexport */ Modals_NotYetPaidModal; },
  "Mw": function() { return /* reexport */ Modals_ParentConfirmModal; },
  "zw": function() { return /* reexport */ Modals_ParentErrorModal; },
  "hT": function() { return /* reexport */ Modals_SimpleSuccessModal; },
  "y6": function() { return /* reexport */ Modals_UserSessionModal; }
});

// UNUSED EXPORTS: DeleteFiscalFileModal, ModalConfirmToCall, PasswordAuditModal, SetMailboxPassword

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
;// CONCATENATED MODULE: ./components/Modals/NotYetPaidModal/messages.js
var statusMessages = {
    BROKER_HAS_NOT_PAID: 'Tu cuenta ha sido bloqueada por falta de pago',
    BROKER_BROKE_CODE_OF_ETHICS: 'Tu cuenta ha sido bloqueada por violaci\xf3n al c\xf3digo de \xe9tica'
};
var getMessage = function(hasPaid, userStatus, blockedReason) {
    if (!hasPaid) {
        return 'Completa tu pago para poder acceder';
    }
    if (userStatus === 'PENDING') {
        return 'Tu cuenta a\xfan no est\xe1 activada';
    }
    if (userStatus === 'ACTIVE') {
        return '';
    }
    return statusMessages[blockedReason];
};

// EXTERNAL MODULE: ./app/selectors/index.js
var selectors = __webpack_require__(11256);
// EXTERNAL MODULE: ./app/services/config.js
var config = __webpack_require__(17698);
// EXTERNAL MODULE: ./globalConfigApp/index.js + 1 modules
var globalConfigApp = __webpack_require__(19169);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
;// CONCATENATED MODULE: ./components/Modals/NotYetPaidModal/styles.js

var _defaultExport = new String(".content.jsx-834337596ce82534{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\npadding:1.25rem;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\nh3.jsx-834337596ce82534{".concat((0,theme/* getFont */.qT)('semiBold', 'h4'), ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex}\nh3.jsx-834337596ce82534>i{color:").concat(theme/* colors.primary */.O9.primary, ";\nmargin-right:0.5rem}\n.content.jsx-834337596ce82534>p.jsx-834337596ce82534{margin:0.5rem 0}\n.highlight.jsx-834337596ce82534{").concat((0,theme/* getFont */.qT)('semiBold', 'p'), "}\n.content.jsx-834337596ce82534 button.logout{margin:1rem auto;\nmax-width:18.625rem;\nmin-width:10rem}\n.link.jsx-834337596ce82534{color:").concat(theme/* colors.primary */.O9.primary, "}"));
_defaultExport.__hash = "834337596ce82534";
/* harmony default export */ var styles = (_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/NotYetPaidModal/index.js













function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var NotYetPaidModal = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(NotYetPaidModal, Component1);
    var _super = _createSuper(NotYetPaidModal);
    function NotYetPaidModal() {
        _classCallCheck(this, NotYetPaidModal);
        return _super.apply(this, arguments);
    }
    _createClass(NotYetPaidModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, hasPaid = _props.hasPaid, token = _props.token, mailbox = _props.mailbox, userPlans = _props.userPlans, userStatus = _props.userStatus, hasKit = _props.hasKit;
                if (hasPaid && !mailbox && (userPlans.includes(config/* PLANS.FULL_SERVICE */.Xf.FULL_SERVICE) || userPlans.includes(config/* PLANS.IN_HOUSE_FULL */.Xf.IN_HOUSE_FULL)) || userStatus !== 'ACTIVE' && userStatus !== 'BLOCKED') {
                    next_router["default"].replace({
                        pathname: '/dashboard/broker-info',
                        query: {
                            t: token
                        }
                    }, {
                        pathname: "/dashboard/broker-info",
                        query: {
                            t: token
                        }
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, hasPaid = _props.hasPaid, userStatus = _props.userStatus, blockedReason = _props.blockedReason, userPlans = _props.userPlans, showNotYetPaidModal = _props.showNotYetPaidModal;
                if (!showNotYetPaidModal) {
                    return null;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, {
                    isOpen: !hasPaid && (userPlans.includes(config/* PLANS.FULL_SERVICE */.Xf.FULL_SERVICE) || userPlans.includes(config/* PLANS.IN_HOUSE_FULL */.Xf.IN_HOUSE_FULL)) || userStatus !== 'ACTIVE',
                    showCloseButton: false,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "jsx-".concat(styles.__hash) + " " + "content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: "jsx-".concat(styles.__hash),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                            icon: "ios-speedometer"
                                        }),
                                        " \xa1Bienvenido a tu dashboard!"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "jsx-".concat(styles.__hash),
                                    children: getMessage(hasPaid, userStatus, blockedReason)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "jsx-".concat(styles.__hash) + " " + "highlight",
                                    children: [
                                        "Si tienes dudas, escr\xedbenos a",
                                        ' ',
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:info@".concat(globalConfigApp/* companyConfig.companyDomain */.p2.companyDomain, "?Subject=").concat(globalConfigApp/* companyConfig.name */.p2.name, " Acceso"),
                                            target: "_top",
                                            className: "jsx-".concat(styles.__hash) + " " + "link",
                                            children: "info@".concat(globalConfigApp/* companyConfig.companyDomain */.p2.companyDomain)
                                        })
                                    ]
                                }),
                                (!hasPaid || blockedReason === 'BROKER_HAS_NOT_PAID') && /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                    href: "/dashboard/payments",
                                    color: "primary",
                                    fullWidth: true,
                                    className: "logout",
                                    children: "Pagar"
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: styles.__hash,
                            children: styles
                        })
                    ]
                }));
            }
        }
    ]);
    return NotYetPaidModal;
}(react.Component);
_defineProperty(NotYetPaidModal, "propTypes", {
    hasPaid: (prop_types_default()).bool,
    userStatus: (prop_types_default()).string
});
var mapStateToProps = function(state) {
    var profile = (0,selectors/* getUserProfile */.et)(state);
    return {
        hasPaid: Boolean(profile.hasPaid),
        userStatus: profile.status,
        hasKit: profile.hasKit,
        blockedReason: profile.blockedReason,
        mailbox: profile.mailbox,
        userPlans: (0,selectors/* getUserPlans */.gQ)(state),
        showNotYetPaidModal: (0,selectors/* showNotYetPaidModalSelector */.Q7)(state),
        token: state.auth.token
    };
};
/* harmony default export */ var Modals_NotYetPaidModal = ((0,es/* connect */.$j)(mapStateToProps)(NotYetPaidModal));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./app/services/index.js + 2 modules
var services = __webpack_require__(64380);
// EXTERNAL MODULE: ./app/services/store/index.js + 1 modules
var store = __webpack_require__(27293);
// EXTERNAL MODULE: ./node_modules/redux-form/es/Field.js + 8 modules
var Field = __webpack_require__(44515);
// EXTERNAL MODULE: ./node_modules/redux-form/es/reduxForm.js + 13 modules
var reduxForm = __webpack_require__(78938);
// EXTERNAL MODULE: ./controls/Input/index.js
var Input = __webpack_require__(24493);
// EXTERNAL MODULE: ./controls/Button/index.js + 17 modules
var Button = __webpack_require__(68030);
// EXTERNAL MODULE: ./controls/utils/react-flexbox-grid.js
var react_flexbox_grid = __webpack_require__(91584);
// EXTERNAL MODULE: ./app/theme/fonts.js
var fonts = __webpack_require__(18437);
;// CONCATENATED MODULE: ./components/Forms/BrokerNote/style.js


var style_defaultExport = new String(".form-container.jsx-d94782415c87f2b2{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nmax-width:540px;\nwidth:100%;\npadding:1rem}\nh4.jsx-d94782415c87f2b2{font:".concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(fonts/* fontSizes.h4 */.CH.h4, ";\ntext-align:left;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0px}\n.legend.jsx-d94782415c87f2b2{font-family:'Source Sans Pro', sans-serif;\nfont-size:14px;\ntext-align:left;\ncolor:").concat(theme/* colors.lightText */.O9.lightText, ";\nmargin:10px 0px}\n.form-container.jsx-d94782415c87f2b2 .actions{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column}\n.form-container.jsx-d94782415c87f2b2 .submit{margin:10px 0}"));
style_defaultExport.__hash = "d94782415c87f2b2";
/* harmony default export */ var BrokerNote_style = (style_defaultExport);

// EXTERNAL MODULE: ./components/Forms/styles.js
var Forms_styles = __webpack_require__(59889);
// EXTERNAL MODULE: ./components/Editor/index.js + 1 modules
var Editor = __webpack_require__(51713);
// EXTERNAL MODULE: ./app/services/validators.js
var validators = __webpack_require__(82257);
;// CONCATENATED MODULE: ./app/validators/brokerNote.js

/* harmony default export */ function brokerNote(values) {
    var errors = {};
    if (!(0,validators/* required */.C1)(values.title)) {
        errors.title = 'T\xedtulo requerido';
    }
    if (!(0,validators/* required */.C1)(values.content)) {
        errors.content = 'Contenido requerido';
    }
    return errors;
};

;// CONCATENATED MODULE: ./components/Forms/BrokerNote/index.js














function BrokerNote_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function BrokerNote_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function BrokerNote_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function BrokerNote_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) BrokerNote_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) BrokerNote_defineProperties(Constructor, staticProps);
    return Constructor;
}
function BrokerNote_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BrokerNote_getPrototypeOf(o) {
    BrokerNote_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return BrokerNote_getPrototypeOf(o);
}
function BrokerNote_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) BrokerNote_setPrototypeOf(subClass, superClass);
}
function BrokerNote_possibleConstructorReturn(self, call) {
    if (call && (BrokerNote_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return BrokerNote_assertThisInitialized(self);
}
function BrokerNote_setPrototypeOf(o, p) {
    BrokerNote_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return BrokerNote_setPrototypeOf(o, p);
}
var BrokerNote_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function BrokerNote_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function BrokerNote_createSuper(Derived) {
    var hasNativeReflectConstruct = BrokerNote_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = BrokerNote_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = BrokerNote_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return BrokerNote_possibleConstructorReturn(this, result);
    };
}
var BrokerNote = /*#__PURE__*/ function(Component1) {
    "use strict";
    BrokerNote_inherits(BrokerNote, Component1);
    var _super = BrokerNote_createSuper(BrokerNote);
    function BrokerNote(props) {
        BrokerNote_classCallCheck(this, BrokerNote);
        var _this;
        _this = _super.call(this, props);
        BrokerNote_defineProperty(BrokerNote_assertThisInitialized(_this), "onEditorStateChange", function(editorState) {
            return _this.setState({
                editorState: editorState
            });
        });
        _this.state = {
            editorState: ''
        };
        return _this;
    }
    BrokerNote_createClass(BrokerNote, [
        {
            key: "render",
            value: function render() {
                var editorState = this.state.editorState;
                var _props = this.props, handleSubmit = _props.handleSubmit, invalid = _props.invalid, style = _props.style, centered = _props.centered;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    style: style,
                    className: "jsx-".concat(Forms_styles/* common.__hash */.y0.__hash, " jsx-").concat(BrokerNote_style.__hash) + " " + "form-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "jsx-".concat(Forms_styles/* common.__hash */.y0.__hash, " jsx-").concat(BrokerNote_style.__hash),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                    icon: "chatbubbles",
                                    style: {
                                        fontSize: '20px',
                                        color: theme/* colors.articBlue */.O9.articBlue,
                                        marginRight: '10px'
                                    }
                                }),
                                "Agregar Nota"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-".concat(Forms_styles/* common.__hash */.y0.__hash, " jsx-").concat(BrokerNote_style.__hash) + " " + "legend",
                            children: ' '
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                    className: "form-input-margin",
                                    name: "title",
                                    id: "title",
                                    component: Input/* InputForm */.M5,
                                    placeholder: "T\xedtulo de la nota"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Col, {
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor/* default */.Z, {
                                        value: editorState,
                                        onChange: this.onEditorStateChange,
                                        className: "editor-container form-input-margin"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        name: "content",
                                        id: "content",
                                        component: Input/* InputHidden */.Rn,
                                        currentValue: editorState
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                xs: 12,
                                className: "actions",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    fullWidth: true,
                                    type: "submit",
                                    className: "submit",
                                    disabled: invalid,
                                    children: "Agregar nota"
                                })
                            })
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: BrokerNote_style.__hash,
                            children: BrokerNote_style
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: Forms_styles/* common.__hash */.y0.__hash,
                            children: Forms_styles/* common */.y0
                        })
                    ]
                }));
            }
        }
    ]);
    return BrokerNote;
}(react.Component);
BrokerNote_defineProperty(BrokerNote, "propTypes", {
    style: (prop_types_default()).object,
    centered: (prop_types_default()).bool
});
BrokerNote_defineProperty(BrokerNote, "defaultProps", {
    style: {},
    centered: false
});
var formConfig = {
    form: 'BrokerNote',
    validate: brokerNote
};
var ReduxBrokerNote = (0,reduxForm/* default */.Z)(formConfig)(BrokerNote);
/* harmony default export */ var Forms_BrokerNote = ((/* unused pure expression or super */ null && (BrokerNote)));

;// CONCATENATED MODULE: ./components/Forms/BrokerNote/ConnectedBrokerNote.js








function ConnectedBrokerNote_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ConnectedBrokerNote_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ConnectedBrokerNote_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ConnectedBrokerNote_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ConnectedBrokerNote_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ConnectedBrokerNote_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ConnectedBrokerNote_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ConnectedBrokerNote_getPrototypeOf(o) {
    ConnectedBrokerNote_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ConnectedBrokerNote_getPrototypeOf(o);
}
function ConnectedBrokerNote_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ConnectedBrokerNote_setPrototypeOf(subClass, superClass);
}
function ConnectedBrokerNote_possibleConstructorReturn(self, call) {
    if (call && (ConnectedBrokerNote_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ConnectedBrokerNote_assertThisInitialized(self);
}
function ConnectedBrokerNote_setPrototypeOf(o, p) {
    ConnectedBrokerNote_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ConnectedBrokerNote_setPrototypeOf(o, p);
}
var ConnectedBrokerNote_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ConnectedBrokerNote_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ConnectedBrokerNote_createSuper(Derived) {
    var hasNativeReflectConstruct = ConnectedBrokerNote_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ConnectedBrokerNote_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ConnectedBrokerNote_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ConnectedBrokerNote_possibleConstructorReturn(this, result);
    };
}
var ConnectedBrokerNote = /*#__PURE__*/ function(Component1) {
    "use strict";
    ConnectedBrokerNote_inherits(ConnectedBrokerNote, Component1);
    var _super = ConnectedBrokerNote_createSuper(ConnectedBrokerNote);
    function ConnectedBrokerNote(props) {
        ConnectedBrokerNote_classCallCheck(this, ConnectedBrokerNote);
        var _this;
        _this = _super.call(this, props);
        ConnectedBrokerNote_defineProperty(ConnectedBrokerNote_assertThisInitialized(_this), "createNote", function(values) {
            var directAnnonceLeadAssignation = _this.props.leadId;
            var title = values.title, content = values.content;
            _this.props.actions.createNoteRequest({
                title: title,
                content: content,
                directAnnonceLeadAssignation: directAnnonceLeadAssignation
            });
            _this.props.closeModal();
        });
        _this.state = {
            formValues: {}
        };
        return _this;
    }
    ConnectedBrokerNote_createClass(ConnectedBrokerNote, [
        {
            key: "render",
            value: function render() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ReduxBrokerNote, {
                    onSubmit: this.createNote
                }));
            }
        }
    ]);
    return ConnectedBrokerNote;
}(react.Component);
var ConnectedBrokerNote_mapStateToProps = function(state) {
    return {
        noteRequestState: store/* default.create */.Z.create('brokerNote').selector(state)
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            createNoteRequest: store/* default.create */.Z.create('brokerNote').action
        }, dispatch)
    };
};
/* harmony default export */ var BrokerNote_ConnectedBrokerNote = ((0,es/* connect */.$j)(ConnectedBrokerNote_mapStateToProps, mapDispatchToProps)(ConnectedBrokerNote));

;// CONCATENATED MODULE: ./components/Modals/AddNote/index.js






function AddNote_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function AddNote_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function AddNote_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function AddNote_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) AddNote_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) AddNote_defineProperties(Constructor, staticProps);
    return Constructor;
}
function AddNote_getPrototypeOf(o) {
    AddNote_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return AddNote_getPrototypeOf(o);
}
function AddNote_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) AddNote_setPrototypeOf(subClass, superClass);
}
function AddNote_possibleConstructorReturn(self, call) {
    if (call && (AddNote_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return AddNote_assertThisInitialized(self);
}
function AddNote_setPrototypeOf(o, p) {
    AddNote_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return AddNote_setPrototypeOf(o, p);
}
var AddNote_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function AddNote_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function AddNote_createSuper(Derived) {
    var hasNativeReflectConstruct = AddNote_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = AddNote_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = AddNote_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return AddNote_possibleConstructorReturn(this, result);
    };
}
var AddNote = /*#__PURE__*/ function(Component1) {
    "use strict";
    AddNote_inherits(AddNote, Component1);
    var _super = AddNote_createSuper(AddNote);
    function AddNote() {
        AddNote_classCallCheck(this, AddNote);
        return _super.apply(this, arguments);
    }
    AddNote_createClass(AddNote, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, isAddingNote = _props.isAddingNote, lead = _props.lead, onClose = _props.onClose;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Modal */.u_, {
                    isOpen: isAddingNote,
                    onClose: onClose,
                    width: "100%",
                    maxWidth: "540px",
                    coverOnMobile: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokerNote_ConnectedBrokerNote, {
                        leadId: lead.id,
                        closeModal: onClose
                    })
                }));
            }
        }
    ]);
    return AddNote;
}(react.Component);
/* harmony default export */ var Modals_AddNote = (AddNote);

// EXTERNAL MODULE: ./components/Modals/ConfirmAction/index.js
var ConfirmAction = __webpack_require__(43774);
// EXTERNAL MODULE: ./controls/Modal/index.js + 1 modules
var Modal = __webpack_require__(95454);
;// CONCATENATED MODULE: ./components/Modals/DeleteFiscalFileModal/styles.js
var styles_defaultExport = new String(".modal-message.jsx-569d8839e8c79d09{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center;\nmargin:2rem;\nmargin-bottom:1rem}\n.modal-message.jsx-569d8839e8c79d09 .name-file.jsx-569d8839e8c79d09{font-weight:bold}\n.button-wrapper.jsx-569d8839e8c79d09{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:space-evenly;\njustify-content:space-evenly;\nmargin:1rem}\n.button-wrapper.jsx-569d8839e8c79d09 .button.jsx-569d8839e8c79d09{margin:2rem}");
styles_defaultExport.__hash = "569d8839e8c79d09";
/* harmony default export */ var DeleteFiscalFileModal_styles = (styles_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/DeleteFiscalFileModal/index.js







var DeleteFiscalFileModal = function(param) {
    var isShowModal = param.isShowModal, closeModal = param.closeModal, filePreDelete = param.filePreDelete, onClickCancel = param.onClickCancel, onClickConfirm = param.onClickConfirm;
    if (!filePreDelete) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        /*#__PURE__*/ className: "jsx-".concat(DeleteFiscalFileModal_styles.__hash),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                isOpen: isShowModal,
                onClose: closeModal,
                showCloseButton: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(DeleteFiscalFileModal_styles.__hash) + " " + "modal-message",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "jsx-".concat(DeleteFiscalFileModal_styles.__hash),
                            children: [
                                "\xbfEst\xe1 seguro que desea borrar el documento:",
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "jsx-".concat(DeleteFiscalFileModal_styles.__hash) + " " + "name-file",
                                    children: filePreDelete.name || ''
                                }),
                                "?"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(DeleteFiscalFileModal_styles.__hash) + " " + "button-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                className: "button",
                                color: "primary",
                                size: "medium",
                                /*#__PURE__*/ outline: true,
                                onClick: onClickCancel,
                                children: "Cancelar"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                className: "button",
                                color: "secondary",
                                size: "medium",
                                outline: true,
                                onClick: onClickConfirm,
                                children: "Confirmar"
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: DeleteFiscalFileModal_styles.__hash,
                children: DeleteFiscalFileModal_styles
            })
        ]
    }));
};
DeleteFiscalFileModal.propTypes = {
    closeModal: (prop_types_default()).func,
    isShowModal: (prop_types_default()).bool,
    filePreDelete: (prop_types_default()).object,
    onClickCancel: (prop_types_default()).func,
    onClickConfirm: (prop_types_default()).func
};
/* harmony default export */ var Modals_DeleteFiscalFileModal = ((/* unused pure expression or super */ null && (DeleteFiscalFileModal)));

;// CONCATENATED MODULE: ./components/Modals/SetMailboxPassword/style.js

var SetMailboxPassword_style_defaultExport = new String(".password-email-container.jsx-347f525753a7fc24{padding:1rem}\n.password-email-container.password-loading.jsx-347f525753a7fc24, .password-email-container.password-success.jsx-347f525753a7fc24{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ntext-align:center;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center}\n.password-email-container.password-success.jsx-347f525753a7fc24 h4.jsx-347f525753a7fc24{color:".concat(theme/* colors.primary */.O9.primary, "}\n.error-password.jsx-347f525753a7fc24{font-weight:bold;\ncolor:").concat(theme/* colors.danger */.O9.danger, "}\n.disclaimer-password.jsx-347f525753a7fc24{display:none}\n@media screen and (max-width:992px) {.disclaimer-password.jsx-347f525753a7fc24{display:initial}}"));
SetMailboxPassword_style_defaultExport.__hash = "347f525753a7fc24";
/* harmony default export */ var style = (SetMailboxPassword_style_defaultExport);

;// CONCATENATED MODULE: ./app/validators/setPasswordMailbox.js

/* harmony default export */ function setPasswordMailbox(values) {
    var errors = {};
    if (!(0,validators/* required */.C1)(values.firtsPassword)) {
        errors.firtsPassword = 'Contrase\xf1a requerida';
    } else if (!(0,validators/* minLength */.Ei)(values.firtsPassword, 8)) {
        errors.firtsPassword = 'Contrase\xf1a muy corta';
    } else if (!(0,validators/* maxLength */.BS)(values.firtsPassword, 20)) {
        errors.firtsPassword = 'Contrase\xf1a muy larga';
    }
    if (!(0,validators/* required */.C1)(values.confirmPassword)) {
        errors.confirmPassword = 'Confirmaci\xf3n requerida';
    }
    if (!(0,validators/* matches */.wB)(values.firtsPassword, values.confirmPassword)) {
        errors.confirmPassword = 'Error en la confirmaci\xf3n';
    }
    return errors;
};

;// CONCATENATED MODULE: ./components/Modals/SetMailboxPassword/index.js









function SetMailboxPassword_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function SetMailboxPassword_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function SetMailboxPassword_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function SetMailboxPassword_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) SetMailboxPassword_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) SetMailboxPassword_defineProperties(Constructor, staticProps);
    return Constructor;
}
function SetMailboxPassword_getPrototypeOf(o) {
    SetMailboxPassword_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return SetMailboxPassword_getPrototypeOf(o);
}
function SetMailboxPassword_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) SetMailboxPassword_setPrototypeOf(subClass, superClass);
}
function SetMailboxPassword_possibleConstructorReturn(self, call) {
    if (call && (SetMailboxPassword_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return SetMailboxPassword_assertThisInitialized(self);
}
function SetMailboxPassword_setPrototypeOf(o, p) {
    SetMailboxPassword_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return SetMailboxPassword_setPrototypeOf(o, p);
}
var SetMailboxPassword_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function SetMailboxPassword_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function SetMailboxPassword_createSuper(Derived) {
    var hasNativeReflectConstruct = SetMailboxPassword_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = SetMailboxPassword_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = SetMailboxPassword_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return SetMailboxPassword_possibleConstructorReturn(this, result);
    };
}
var SetMailboxPassword = /*#__PURE__*/ function(Component1) {
    "use strict";
    SetMailboxPassword_inherits(SetMailboxPassword, Component1);
    var _super = SetMailboxPassword_createSuper(SetMailboxPassword);
    function SetMailboxPassword() {
        SetMailboxPassword_classCallCheck(this, SetMailboxPassword);
        return _super.apply(this, arguments);
    }
    SetMailboxPassword_createClass(SetMailboxPassword, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, handleSubmit = _props.handleSubmit, confirmed = _props.confirmed, loading = _props.loading, errorApi = _props.errorApi;
                if (!confirmed && !loading && !errorApi) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(style.__hash) + " " + "password-email-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "jsx-".concat(style.__hash),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "jsx-".concat(style.__hash) + " " + "disclaimer-password",
                                        children: "\xbfQuieres recibir los correos en tu celular?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "jsx-".concat(style.__hash) + " " + "hideOnMobile",
                                        children: "\xa1Genial! Ahora ingresa tu contrase\xf1a"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-".concat(style.__hash),
                                        children: "Ingresa una nueva contrase\xf1a para acceder al servicio de env\xedo por tel\xe9fono."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        type: "password",
                                        placeholder: "Contrase\xf1a",
                                        className: "form-input-margin",
                                        component: Input/* InputForm */.M5,
                                        name: "firtsPassword",
                                        id: "firtsPassword",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                        type: "password",
                                        placeholder: "Repite contrase\xf1a",
                                        className: "form-input-margin",
                                        component: Input/* InputForm */.M5,
                                        name: "confirmPassword",
                                        id: "confirmPassword",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-".concat(style.__hash),
                                        children: "La contrase\xf1a debe ser alfanum\xe9rica de m\xednimo 8 caracteres"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                        color: "primary",
                                        type: "submit",
                                        fullWidth: true,
                                        children: "Confirmar"
                                    })
                                ]
                            }),
                            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                                id: style.__hash,
                                children: style
                            })
                        ]
                    }));
                }
                if (loading && !errorApi) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(style.__hash) + " " + "password-email-container password-loading",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                size: 50,
                                thickness: 5,
                                style: {
                                    margin: '20px auto'
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-".concat(style.__hash),
                                children: "Cargando"
                            }),
                            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                                id: style.__hash,
                                children: style
                            })
                        ]
                    }));
                }
                if (confirmed && !loading && !errorApi) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(style.__hash) + " " + "password-email-container password-success",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "jsx-".concat(style.__hash),
                                children: "Tu contrase\xf1a ha sido actualizada correctamente."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,services/* image */.BH)('icons/icono-admin-mensaje-enviado-copy.svg'),
                                alt: "Contrase\xf1a asignada con \xe9xito",
                                className: "jsx-".concat(style.__hash)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "jsx-".concat(style.__hash),
                                children: "Ahora podr\xe1s ver tus correos desde tu tel\xe9fono."
                            }),
                            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                                id: style.__hash,
                                children: style
                            })
                        ]
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(style.__hash) + " " + "password-email-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "jsx-".concat(style.__hash),
                            children: "Lo sentimos, hubo un error, intenta m\xe1s tarde con una nueva contrase\xf1a."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "jsx-".concat(style.__hash),
                            children: " S\xed el problema persiste, por favor comun\xedcate con nosotros. "
                        }),
                        (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                            id: style.__hash,
                            children: style
                        })
                    ]
                }));
            }
        }
    ]);
    return SetMailboxPassword;
}(react.Component);
var SetMailboxPassword_formConfig = {
    form: 'passwordMailboxForm',
    validate: setPasswordMailbox
};
var ReduxSetMailboxPassword = (0,reduxForm/* default */.Z)(SetMailboxPassword_formConfig)(SetMailboxPassword);
/* harmony default export */ var Modals_SetMailboxPassword = ((/* unused pure expression or super */ null && (SetMailboxPassword)));

// EXTERNAL MODULE: ./components/Modals/ModalConfirm/index.js + 1 modules
var ModalConfirm = __webpack_require__(82041);
// EXTERNAL MODULE: ./app/services/media.js
var media = __webpack_require__(30471);
;// CONCATENATED MODULE: ./components/Modals/ModalConfirmToCall/styles.js

var ModalConfirmToCall_styles_defaultExport = new String(".action-message.jsx-fc7fc6f331b81976{margin:0.5rem 0}\n.telephone.jsx-fc7fc6f331b81976{background-color:".concat(theme/* colors.lightGray */.O9.lightGray, ";\nfont-weight:").concat(theme/* fontWeights.semiBold */.vC.semiBold, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\npadding:0.4rem;\nmargin:0}"));
ModalConfirmToCall_styles_defaultExport.__hash = "fc7fc6f331b81976";
/* harmony default export */ var ModalConfirmToCall_styles = (ModalConfirmToCall_styles_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/ModalConfirmToCall/index.js







var ModalConfirmToCall = function(param) {
    var telephone = param.telephone, contactName = param.contactName, message = param.message, openModal = param.openModal, onCancel = param.onCancel, onConfirm = param.onConfirm;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        /*#__PURE__*/ className: "jsx-".concat(ModalConfirmToCall_styles.__hash),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalConfirm/* default */.Z, {
                isOpen: openModal,
                message: message,
                buttonConfirmLabel: "Llamar ahora",
                onCancel: onCancel,
                onConfirm: function() {
                    (0,media/* mobilCallPhone */.g7)(telephone);
                    onConfirm();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "jsx-".concat(ModalConfirmToCall_styles.__hash) + " " + "action-message",
                        children: [
                            "\xbfDeseas llamar a ",
                            contactName,
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-".concat(ModalConfirmToCall_styles.__hash) + " " + "telephone",
                        children: telephone
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: ModalConfirmToCall_styles.__hash,
                children: ModalConfirmToCall_styles
            })
        ]
    }));
};
ModalConfirmToCall.propTypes = {
    telephone: (prop_types_default()).string.isRequired,
    contactName: (prop_types_default()).string.isRequired,
    message: (prop_types_default()).string.isRequired,
    openModal: (prop_types_default()).bool.isRequired,
    onCancel: (prop_types_default()).func.isRequired,
    onConfirm: (prop_types_default()).func.isRequired
};
/* harmony default export */ var Modals_ModalConfirmToCall = ((/* unused pure expression or super */ null && (ModalConfirmToCall)));

// EXTERNAL MODULE: ./app/theme/colors.js
var colors = __webpack_require__(32080);
;// CONCATENATED MODULE: ./components/Modals/SimpleSuccessModal/styles.js

var SimpleSuccessModal_styles_defaultExport = new String(".title.jsx-82f1bbeba07f5f8b{color:".concat(colors/* iadProvitionalColors.primary */.Du.primary, "}"));
SimpleSuccessModal_styles_defaultExport.__hash = "82f1bbeba07f5f8b";
/* harmony default export */ var SimpleSuccessModal_styles = (SimpleSuccessModal_styles_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/SimpleSuccessModal/index.js








function SimpleSuccessModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SimpleSuccessModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var SimpleSuccessModal = function(_param) {
    var title = _param.title, children = _param.children, imageIcon = _param.imageIcon, onConfirm = _param.onConfirm, onCancel = _param.onCancel, isOpen = _param.isOpen, rest = _objectWithoutProperties(_param, [
        "title",
        "children",
        "imageIcon",
        "onConfirm",
        "onCancel",
        "isOpen"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalConfirm/* default */.Z, _objectSpread({
        showRejectButton: false,
        isOpen: isOpen,
        onConfirm: onConfirm || onCancel,
        onCancel: onCancel
    }, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                size: "large",
                style: {
                    color: colors/* iadProvitionalColors.primary */.Du.primary
                },
                icon: "md-checkmark-circle-outline"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "jsx-".concat(SimpleSuccessModal_styles.__hash) + " " + "title",
                children: title
            }),
            children,
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: SimpleSuccessModal_styles.__hash,
                children: SimpleSuccessModal_styles
            })
        ]
    })));
};
SimpleSuccessModal.defaultProps = {
    title: 'Mensaje enviado con \xe9xito'
};
SimpleSuccessModal.propTypes = {
    title: (prop_types_default()).string,
    children: (prop_types_default()).any,
    imageIcon: (prop_types_default()).string,
    onCancel: (prop_types_default()).func.isRequired,
    onConfirm: (prop_types_default()).func,
    isOpen: (prop_types_default()).bool
};
/* harmony default export */ var Modals_SimpleSuccessModal = (SimpleSuccessModal);

// EXTERNAL MODULE: ./components/index.js + 34 modules
var components = __webpack_require__(553);
// EXTERNAL MODULE: ./app/config/index.js + 1 modules
var app_config = __webpack_require__(68080);
// EXTERNAL MODULE: ./app/reducers/UserSessionRedux.js
var UserSessionRedux = __webpack_require__(52698);
// EXTERNAL MODULE: ./app/selectors/user.js
var user = __webpack_require__(53584);
;// CONCATENATED MODULE: ./components/UserSession/useUserSessionLogger.js



var USER_SESSION_ACTION_TYPES = {
    CREATE_SESSION: 'create-session',
    EXCEEDED_SESSIONS: 'exceeded-sessions',
    REVALIDATE_SESSION: 'revalidate-session'
};
/**
 * @function useUserSessionLogger
 * @param {String} type - one of USER_SESSION_ACTION_TYPES
 * @param {String} message
 */ function useUserSessionLogger(type) {
    var user = (0,es/* useSelector */.v9)(selectors/* getUserProfile */.et);
    var isBrowser = "object" !== 'undefined';
    var currentUrl = isBrowser && window.location.href;
    (0,react.useEffect)(function() {
        if (isBrowser) {
            var domain = window.location.origin;
            var userAgent = window.navigator.userAgent;
            fetch(domain + '/api/user-session-logs/', {
                method: 'POST',
                body: JSON.stringify({
                    message: "[user-sessions][".concat(type, "]: userId: ").concat(user.userId, " | email: ").concat(user.email, " | mailbox: ").concat(user.mailbox, " | ").concat(currentUrl, " | ").concat(userAgent)
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            }).catch(function(err) {
                return console.error('useUserSessionLogger error: ', err);
            });
        }
    }, [
        type,
        isBrowser,
        currentUrl
    ]);
}
/* harmony default export */ var UserSession_useUserSessionLogger = (useUserSessionLogger);

// EXTERNAL MODULE: ./components/Feedback/index.js + 1 modules
var Feedback = __webpack_require__(68245);
;// CONCATENATED MODULE: ./components/Forms/UserSessionForm/constants.js
var CODE_VERIFICATION_TYPES = {
    NEW_LOGIN_DEVICE: 'NEW_LOGIN_DEVICE',
    REVALIDATE_SESSION: 'REVALIDATE_SESSION'
};

;// CONCATENATED MODULE: ./components/Forms/UserSessionForm/styles.js

var codeVerificationStyles = new String(".code-verification-message.jsx-dc51f52275c4b5d4{margin-top:0;\ntext-align:center}");
codeVerificationStyles.__hash = "dc51f52275c4b5d4";
var sendCodeVerificationStyles = new String(".send-code-verification-message.jsx-c90139fe38aa6740{margin-top:0;\ntext-align:center}\n.send-code-verification-message.jsx-c90139fe38aa6740 p.jsx-c90139fe38aa6740{margin-top:0}\n.send-code-button-container.jsx-c90139fe38aa6740 .send-code-button{padding:0 2rem;\nfont-weight:".concat(theme/* fontWeights.semiBold */.vC.semiBold, "}"));
sendCodeVerificationStyles.__hash = "c90139fe38aa6740";
var deviceHeaderStyles = new String(".device-header.jsx-61897355623259ca{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.title.jsx-61897355623259ca{margin:0}\n.device-header.jsx-61897355623259ca .header-logo.jsx-61897355623259ca{margin-right:0.5rem}");
deviceHeaderStyles.__hash = "61897355623259ca";
var deviceFooterStyles = new String(".device-footer.jsx-739f2950504e74f0{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\nmargin:0 1rem}");
deviceFooterStyles.__hash = "739f2950504e74f0";
var registerNewDeviceFormStyles = new String(".register-new-device-form.jsx-35947af46aa5be4a{width:100%}\n.register-new-device-input-container.jsx-35947af46aa5be4a{min-height:6rem}\n.register-code-verification.jsx-35947af46aa5be4a{margin-top:0;\nmargin-bottom:2rem}\n.register-button-container.jsx-35947af46aa5be4a{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n.register-button-container.jsx-35947af46aa5be4a .register-button{padding:0 2rem;\nfont-weight:".concat(theme/* fontWeights.semiBold */.vC.semiBold, "}"));
registerNewDeviceFormStyles.__hash = "35947af46aa5be4a";
var dontShareCodeStyles = new String(".security-warning.jsx-90cbbf77e714335{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmargin-top:1.5rem}\n.security-warning.jsx-90cbbf77e714335 .security-warning-icon{margin-right:0.5rem;\ncolor:".concat(theme/* colors.frame */.O9.frame, "}"));
dontShareCodeStyles.__hash = "90cbbf77e714335";

;// CONCATENATED MODULE: ./components/Forms/UserSessionForm/CodeVerification.js













function CodeVerification_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CodeVerification_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CodeVerification_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CODE_SIZE = 6;
var CODE_ERRORS = {
    'Code expired': 'Tu c\xf3digo expir\xf3. Solicita otro e intenta de nuevo.'
};
var CodeVerification = function(param) {
    var _codeVerificationType = param.codeVerificationType, codeVerificationType = _codeVerificationType === void 0 ? CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE : _codeVerificationType;
    var sendVerificationCode = function sendVerificationCode() {
        dispatch(services/* store.sendVerificationCode */.h.sendVerificationCode('user').action(codeVerificationType, email));
        dispatch(services/* store.confirmVerificationCode */.h.confirmVerificationCode('user').clear());
    };
    var sendCode = function sendCode() {
        sendVerificationCode();
        setCodeSent(true);
    };
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var email = (0,es/* useSelector */.v9)(selectors/* getUserProfile */.et).email;
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ codeSent = ref1[0], setCodeSent = ref1[1];
    var sendCodeFeedback = (0,es/* useSelector */.v9)(services/* store.sendVerificationCode */.h.sendVerificationCode('user').selector);
    var confirmCodeFeedback = (0,es/* useSelector */.v9)(services/* store.confirmVerificationCode */.h.confirmVerificationCode('user').selector);
    var confirmSuccess = (0,es/* useSelector */.v9)(user/* confirmVerificationCodeSuccessSelector */.AR);
    (0,react.useEffect)(function() {
        return function() {
            dispatch(services/* store.sendVerificationCode */.h.sendVerificationCode('user').clear());
            dispatch(services/* store.confirmVerificationCode */.h.confirmVerificationCode('user').clear());
        };
    }, []);
    var verifyCode = function(code) {
        if (code && code.length === CODE_SIZE) {
            dispatch(services/* store.confirmVerificationCode */.h.confirmVerificationCode('user').action(codeVerificationType, code, email));
        }
    };
    if (confirmSuccess) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Card */.Zb, {
            success: true,
            small: true,
            rounded: true,
            children: "C\xf3digo confirmado, ahora puedes registrar esta sesi\xf3n."
        }));
    }
    if (!codeSent) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-qa": "send-code-verification",
            className: "jsx-".concat(sendCodeVerificationStyles.__hash) + " " + "send-code-verification-message",
            children: [
                codeVerificationType === CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "jsx-".concat(sendCodeVerificationStyles.__hash),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "jsx-".concat(sendCodeVerificationStyles.__hash),
                        children: "Verifica que esta sesi\xf3n te pertenece"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "jsx-".concat(sendCodeVerificationStyles.__hash),
                    children: [
                        "Enviar c\xf3digo de verificaci\xf3n a ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "jsx-".concat(sendCodeVerificationStyles.__hash),
                            children: email
                        }),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-".concat(sendCodeVerificationStyles.__hash) + " " + "send-code-button-container form-input-margin",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                        onClick: sendCode,
                        size: "large",
                        color: "primary",
                        className: "send-code-button",
                        children: "Enviar"
                    })
                }),
                (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                    id: sendCodeVerificationStyles.__hash,
                    children: sendCodeVerificationStyles
                })
            ]
        }));
    }
    if (sendCodeFeedback.loading || sendCodeFeedback.error || sendCodeFeedback.error || !Boolean(sendCodeFeedback.response)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback/* default */.Z, CodeVerification_objectSpread({}, sendCodeFeedback)));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-qa": "code-verification",
        className: "jsx-".concat(codeVerificationStyles.__hash) + " " + "code-verification",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-".concat(codeVerificationStyles.__hash) + " " + "code-verification-message",
                children: [
                    globalConfigApp/* companyConfig.name */.p2.name,
                    " te acaba de enviar un email a ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "jsx-".concat(codeVerificationStyles.__hash),
                        children: email
                    }),
                    " con un c\xf3digo de verificaci\xf3n. Ingresalo a continuaci\xf3n:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    margin: '0 auto',
                    width: 'fit-content'
                },
                className: "jsx-".concat(codeVerificationStyles.__hash),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* ReactCodeInput */.KM, {
                    className: "form-input-margin",
                    name: "code",
                    type: "number",
                    fields: CODE_SIZE,
                    onChange: verifyCode
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback/* default */.Z, CodeVerification_objectSpread({}, confirmCodeFeedback, {
                messageError: CODE_ERRORS[confirmCodeFeedback === null || confirmCodeFeedback === void 0 ? void 0 : (ref = confirmCodeFeedback.error) === null || ref === void 0 ? void 0 : ref.detail] || 'Error en tu c\xf3digo, solicita otro e intenta de nuevo.'
            })),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: codeVerificationStyles.__hash,
                children: codeVerificationStyles
            })
        ]
    }));
};
/* harmony default export */ var UserSessionForm_CodeVerification = (CodeVerification);

;// CONCATENATED MODULE: ./components/Forms/UserSessionForm/Commons.js













var DeviceHeader = function(param) {
    var title = param.title;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
        className: /*#__PURE__*/ "jsx-".concat(deviceHeaderStyles.__hash) + " " + "device-header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,services/* image */.BH)('icons/icon-devices.svg'),
                alt: "",
                className: "jsx-".concat(deviceHeaderStyles.__hash) + " " + "header-logo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "jsx-".concat(deviceHeaderStyles.__hash) + " " + "title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: "jsx-".concat(deviceHeaderStyles.__hash),
                    children: title
                })
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: deviceHeaderStyles.__hash,
                children: deviceHeaderStyles
            })
        ]
    }));
};
var DeviceFooter = function(param) {
    var children = param.children;
    var logout = function logout() {
        window.location.assign('/salir');
    };
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Divider */.iz, {
                color: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(deviceFooterStyles.__hash) + " " + "device-footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                        onClick: logout,
                        children: "Salir"
                    }),
                    children,
                    (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                        id: deviceFooterStyles.__hash,
                        children: deviceFooterStyles
                    })
                ]
            })
        ]
    }));
};
var DontShareCode = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
        className: "jsx-".concat(dontShareCodeStyles.__hash) + " " + "security-warning",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                size: "small",
                className: "security-warning-icon",
                icon: "md-close-circle-outline"
            }),
            ' ',
            "No compartas tu c\xf3digo.",
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: dontShareCodeStyles.__hash,
                children: dontShareCodeStyles
            })
        ]
    });
};
var SendVerificationCode = function(param) {
    var _codeVerificationType = param.codeVerificationType, codeVerificationType = _codeVerificationType === void 0 ? CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE : _codeVerificationType;
    var sendVerificationCode = function sendVerificationCode() {
        dispatch(services/* store.sendVerificationCode */.h.sendVerificationCode('user').action(codeVerificationType, email));
        dispatch(services/* store.confirmVerificationCode */.h.confirmVerificationCode('user').clear());
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var email = (0,es/* useSelector */.v9)(selectors/* getUserProfile */.et).email;
    var sendCodeFeedback = (0,es/* useSelector */.v9)(services/* store.sendVerificationCode */.h.sendVerificationCode('user').selector);
    var confirmSuccess = (0,es/* useSelector */.v9)(user/* confirmVerificationCodeSuccessSelector */.AR);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
        onClick: sendVerificationCode,
        disabled: !sendCodeFeedback.request || confirmSuccess,
        children: "Solicitar un c\xf3digo nuevo"
    }));
};

;// CONCATENATED MODULE: ./components/Forms/UserSessionForm/RegisterNewDevice.js












function RegisterNewDevice_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RegisterNewDevice_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RegisterNewDevice_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MAPPED_ERRORS = {
    'user session with this alias already exists.': 'Este alias ya existe, por favor ingrese uno diferente.'
};
function getFieldError(name, error, errors) {
    if (error) {
        var fieldErrors = errors[name] || [];
        var fieldError = fieldErrors[0];
        return {
            touched: true,
            invalid: fieldErrors.length > 0,
            error: MAPPED_ERRORS[fieldError] || fieldError
        };
    }
}
function RegisterNewDeviceForm() {
    var createDevice = function createDevice() {
        dispatch(UserSessionRedux/* UserSessionActionCreators.createSessionRequest */.nO.createSessionRequest(alias));
    };
    var onChange = function onChange(param) {
        var target = param.target;
        if (error) {
            dispatch(UserSessionRedux/* UserSessionActionCreators.cleanFeedback */.nO.cleanFeedback());
        }
        setValues(function(values) {
            return(RegisterNewDevice_objectSpread({}, values, RegisterNewDevice_defineProperty({
                validateAlias: true
            }, target.name, target.value)));
        });
    };
    UserSession_useUserSessionLogger(USER_SESSION_ACTION_TYPES.CREATE_SESSION);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)({
        alias: '',
        validateAlias: false
    }), ref1 = ref[0], alias = ref1.alias, validateAlias = ref1.validateAlias, /*#__PURE__*/ setValues = ref[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return state.userSession.createSessionFeedback;
    }), loading = ref2.loading, success = ref2.success, error = ref2.error, errors = ref2.errors;
    var confirmSuccess = (0,es/* useSelector */.v9)(user/* confirmVerificationCodeSuccessSelector */.AR);
    (0,react.useEffect)(function() {
        dispatch(UserSessionRedux/* UserSessionActionCreators.cleanFeedback */.nO.cleanFeedback());
    }, []);
    var aliasError = validateAlias && alias.length < 6;
    var aliasErrors = aliasError ? {
        alias: [
            alias.length < 6 && 'M\xednimo 6 car\xe1cteres'
        ]
    } : errors;
    var disableCreateDevece = !confirmSuccess || !alias || alias.length < 6;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-qa": "register-new-device-form",
        className: "jsx-".concat(registerNewDeviceFormStyles.__hash) + " " + "register-new-device-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceHeader, {
                title: "Registra tu sesi\xf3n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(registerNewDeviceFormStyles.__hash) + " " + "register-new-device-input-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Input */.II, {
                    name: "alias",
                    value: alias,
                    label: "Alias (m\xednimo 6 car\xe1cteres)",
                    placeholder: "Alias de la sesi\xf3n",
                    onChange: onChange,
                    className: "form-input-margin",
                    meta: getFieldError('alias', aliasError || error, aliasErrors)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(registerNewDeviceFormStyles.__hash) + " " + "register-code-verification form-input-margin",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserSessionForm_CodeVerification, {})
            }),
            confirmSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(registerNewDeviceFormStyles.__hash) + " " + "register-button-container form-input-margin",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                    disabled: disableCreateDevece,
                    loading: loading,
                    onClick: createDevice,
                    size: "large",
                    color: disableCreateDevece ? 'tertiary' : 'primary',
                    className: "register-button",
                    children: "Continuar"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DontShareCode, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceFooter, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendVerificationCode, {
                    codeVerificationType: CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE
                })
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: registerNewDeviceFormStyles.__hash,
                children: registerNewDeviceFormStyles
            })
        ]
    }));
}
/* harmony default export */ var RegisterNewDevice = (RegisterNewDeviceForm);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./controls/Switch/index.js + 1 modules
var Switch = __webpack_require__(80073);
;// CONCATENATED MODULE: ./components/UserSession/LogoutSessions/styles.js

var logoutSessionsStyles = new String(".user-session-logout-container.jsx-cc1172c96642abcf{margin:0 auto;\nwidth:100%}\n.user-session-logout-container-body.jsx-cc1172c96642abcf{margin-top:1rem}\n.session-logout-warning.jsx-cc1172c96642abcf{text-align:center}\n.session-logout-warning.jsx-cc1172c96642abcf i{color:".concat(theme/* colors.danger */.O9.danger, ";\nmargin-right:0.5rem}\n.logout-button-container.jsx-cc1172c96642abcf{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n.logout-button-container.jsx-cc1172c96642abcf .logout-button{padding:0 2rem;\nfont-weight:").concat(theme/* fontWeights.semiBold */.vC.semiBold, "}"));
logoutSessionsStyles.__hash = "cc1172c96642abcf";
var sessionStyles = new String(".session.jsx-91a9e71918e3d018{display:grid;\ngrid-template-columns:3.2rem 1fr;\npadding:1rem 0}\n.session.in-active.jsx-91a9e71918e3d018{color:".concat(theme/* colors.gray */.O9.gray, "}\n.session-details.jsx-91a9e71918e3d018{margin-left:1rem}\n.session-details.jsx-91a9e71918e3d018 .last-login.jsx-91a9e71918e3d018{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:stretch;\n-webkit-box-align:stretch;\n-ms-flex-align:stretch;\nalign-items:stretch;\ncolor:").concat(theme/* colors.gray */.O9.gray, "}\n.session-details.jsx-91a9e71918e3d018 .last-login.jsx-91a9e71918e3d018 span.jsx-91a9e71918e3d018{margin-right:0.2rem}\n.session-alias.jsx-91a9e71918e3d018, .session-info.jsx-91a9e71918e3d018{margin:0.2rem 0 0;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\nflex-wrap:wrap}\n.session-info.jsx-91a9e71918e3d018{color:").concat(theme/* colors.gray */.O9.gray, "}"));
sessionStyles.__hash = "91a9e71918e3d018";

;// CONCATENATED MODULE: ./components/UserSession/LogoutSessions/index.js













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function LogoutSessions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LogoutSessions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LogoutSessions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Session(param) {
    var alias = param.alias, deviceInfo = param.deviceInfo, id = param.id, lastLoggedAt = param.lastLoggedAt, onSwitch = param.onSwitch, checked1 = param.checked;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "jsx-".concat(sessionStyles.__hash) + " " + (classnames_default()("session", {
            'in-active': !checked1
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                checked: checked1,
                onChange: function(checked) {
                    return onSwitch(checked, id);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(sessionStyles.__hash) + " " + "session-details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "jsx-".concat(sessionStyles.__hash) + " " + "session-alias",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                className: "jsx-".concat(sessionStyles.__hash),
                                children: [
                                    " ",
                                    alias,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                className: "jsx-".concat(sessionStyles.__hash) + " " + "last-login",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        className: "jsx-".concat(sessionStyles.__hash),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "jsx-".concat(sessionStyles.__hash),
                                            children: [
                                                "\xdaltimo login ",
                                                moment_default()(lastLoggedAt).fromNow()
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        size: "small",
                                        icon: "md-time"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-".concat(sessionStyles.__hash) + " " + "session-info",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            className: "jsx-".concat(sessionStyles.__hash),
                            children: deviceInfo
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: sessionStyles.__hash,
                children: sessionStyles
            })
        ]
    }));
}
var howManyDevicesShouldBeLogout = function(param) {
    var activeSessions = param.activeSessions, logoutDevices = param.logoutDevices, limitUserActiveSessions = param.limitUserActiveSessions;
    var currrentSession = 1;
    return activeSessions + currrentSession - logoutDevices - limitUserActiveSessions;
};
function LogoutSessions() {
    var hadleLogoutDevices = function hadleLogoutDevices(logoutDevices) {
        dispatch(UserSessionRedux/* UserSessionActionCreators.logoutSessionsRequest */.nO.logoutSessionsRequest(logoutDevices));
    };
    var handleSwitch = function handleSwitch(checked, deviceId) {
        if (checked) {
            setLogoutDevices(function(devices) {
                return devices.filter(function(device) {
                    return device !== deviceId;
                });
            });
        } else {
            setLogoutDevices(function(devices) {
                return _toConsumableArray(devices).concat([
                    deviceId
                ]);
            });
        }
    };
    UserSession_useUserSessionLogger(USER_SESSION_ACTION_TYPES.EXCEEDED_SESSIONS);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), logoutDevices1 = ref[0], setLogoutDevices = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.userSession;
    }), activeSessions = ref1.activeSessions, getSessionsFeedback = ref1.getSessionsFeedback, logoutSessionsFeedback = ref1.logoutSessionsFeedback, limitUserActiveSessions = ref1.limitUserActiveSessions;
    (0,react.useEffect)(function() {
        dispatch(UserSessionRedux/* UserSessionActionCreators.getSessionsRequest */.nO.getSessionsRequest());
    }, []);
    if (!getSessionsFeedback.success) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback/* default */.Z, LogoutSessions_objectSpread({}, getSessionsFeedback)));
    }
    var devicesToLogout = howManyDevicesShouldBeLogout({
        activeSessions: activeSessions.length,
        logoutDevices: logoutDevices1.length,
        limitUserActiveSessions: limitUserActiveSessions
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        "data-qa": "user-session-logout-container",
        className: "jsx-".concat(logoutSessionsStyles.__hash) + " " + "user-session-logout-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceHeader, {
                title: "Sesiones activas"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(logoutSessionsStyles.__hash) + " " + "user-session-logout-container-body",
                children: [
                    activeSessions.map(function(session) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Session, LogoutSessions_objectSpread({}, session, {
                            checked: !logoutDevices1.includes(session.id),
                            onSwitch: handleSwitch
                        }), session.id);
                    }),
                    devicesToLogout > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "jsx-".concat(logoutSessionsStyles.__hash) + " " + "session-logout-warning",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                icon: "md-warning"
                            }),
                            "Necesita desloguear al menos ",
                            devicesToLogout,
                            ' ',
                            devicesToLogout === 1 ? 'sesi\xf3n' : 'sesiones',
                            " m\xe1s."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(logoutSessionsStyles.__hash) + " " + "logout-button-container form-input-margin",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                            onClick: function() {
                                return hadleLogoutDevices(logoutDevices1);
                            },
                            loading: logoutSessionsFeedback.loading,
                            disabled: devicesToLogout > 0,
                            size: "large",
                            className: "logout-button",
                            color: devicesToLogout > 0 ? 'tertiary' : 'primary',
                            children: "Continuar"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceFooter, {}),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: logoutSessionsStyles.__hash,
                children: logoutSessionsStyles
            })
        ]
    }));
}
/* harmony default export */ var UserSession_LogoutSessions = (LogoutSessions);

;// CONCATENATED MODULE: ./components/Forms/UserSessionForm/RevalidateSession.js









function RevalidateSession() {
    UserSession_useUserSessionLogger(USER_SESSION_ACTION_TYPES.REVALIDATE_SESSION);
    var dispatch = (0,es/* useDispatch */.I0)();
    var confirmSuccess = (0,es/* useSelector */.v9)(user/* confirmVerificationCodeSuccessSelector */.AR);
    (0,react.useEffect)(function() {
        if (confirmSuccess) {
            dispatch(UserSessionRedux/* UserSessionActionCreators.revalidateSession */.nO.revalidateSession());
        }
    }, [
        confirmSuccess
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-qa": "revalidate-session",
        className: "revalidate-session",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceHeader, {
                title: "Rev\xe1lida tu sesi\xf3n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    textAlign: 'center'
                },
                children: "Tu sesi\xf3n ha pasado demasiado tiempo inactiva, por ello necesitamos que la revalides."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserSessionForm_CodeVerification, {
                codeVerificationType: CODE_VERIFICATION_TYPES.REVALIDATE_SESSION
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DontShareCode, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceFooter, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendVerificationCode, {
                    codeVerificationType: CODE_VERIFICATION_TYPES.REVALIDATE_SESSION
                })
            })
        ]
    }));
}
/* harmony default export */ var UserSessionForm_RevalidateSession = (RevalidateSession);

;// CONCATENATED MODULE: ./components/Modals/UserSessionModal/styles.js
var userSessionModalStyles = new String(".user-session-modal-body.jsx-a3cb78f1eb859479{position:relative;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center;\nwidth:100%;\npadding:0.5rem 1rem}\n.user-session-modal-body.jsx-a3cb78f1eb859479 .logo.jsx-a3cb78f1eb859479{width:15rem;\nmargin:1rem auto;\nposition:absolute;\ntop:-6rem;\nleft:0;\nright:0}\n.user-session-modal-body.iad.jsx-a3cb78f1eb859479 .logo.jsx-a3cb78f1eb859479{width:100%;\nmax-width:5rem;\nmargin:1rem auto;\nposition:absolute;\ntop:-8rem}\n@media screen and (max-width:500px) {.user-session-modal-body.jsx-a3cb78f1eb859479{padding:0}\n.user-session-modal-body.jsx-a3cb78f1eb859479 .logo.jsx-a3cb78f1eb859479{display:none}}");
userSessionModalStyles.__hash = "a3cb78f1eb859479";

;// CONCATENATED MODULE: ./components/Modals/UserSessionModal/index.js

















var COMPANY_NAME = (0,app_config["default"])('COMPANY_NAME');
var UserSessionModalContent = function(param) {
    var newDevice = param.newDevice, excededDevices = param.excededDevices, shouldBeRevalidated = param.shouldBeRevalidated;
    if (newDevice) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterNewDevice, {}));
    }
    if (excededDevices) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserSession_LogoutSessions, {}));
    }
    if (shouldBeRevalidated) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserSessionForm_RevalidateSession, {}));
    }
    return null;
};
var UserSessionModal = function() {
    var showNotYetPaidModal = (0,es/* useSelector */.v9)(selectors/* showNotYetPaidModalSelector */.Q7);
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.userSession;
    }), excededDevices = ref.excededDevices, fingerprint = ref.fingerprint, newDevice = ref.newDevice, shouldBeLogout = ref.shouldBeLogout, refreshTokenWithTokenAndCreateSessionFeedback = ref.refreshTokenWithTokenAndCreateSessionFeedback, shouldBeRevalidated = ref.shouldBeRevalidated;
    if (!showNotYetPaidModal && !(refreshTokenWithTokenAndCreateSessionFeedback === null || refreshTokenWithTokenAndCreateSessionFeedback === void 0 ? void 0 : refreshTokenWithTokenAndCreateSessionFeedback.loading) && (newDevice || excededDevices || shouldBeRevalidated)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, {
            overlayStyle: {
                backgroundColor: theme/* colors.frame */.O9.frame
            },
            isOpen: !showNotYetPaidModal,
            showCloseButton: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Card */.Zb, {
                    rounded: true,
                    alignLeft: true,
                    "data-qa": "user-session-modal-container",
                    maxWidth: theme/* measurements.containerMediumSize */.kg.containerMediumSize,
                    style: {
                        margin: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(userSessionModalStyles.__hash) + " " + (classnames_default()('user-session-modal-body', {
                            iad: COMPANY_NAME === 'IAD'
                        }) || ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/",
                                target: "_blank",
                                className: "jsx-".concat(userSessionModalStyles.__hash),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,services/* image */.BH)('logo-white.svg'),
                                    alt: globalConfigApp/* companyConfig.name */.p2.name,
                                    className: "jsx-".concat(userSessionModalStyles.__hash) + " " + (classnames_default()("logo", {
                                        'iad': COMPANY_NAME === 'IAD'
                                    }) || "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserSessionModalContent, {
                                newDevice: newDevice,
                                excededDevices: excededDevices,
                                shouldBeRevalidated: shouldBeRevalidated
                            })
                        ]
                    })
                }),
                (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                    id: userSessionModalStyles.__hash,
                    children: userSessionModalStyles
                })
            ]
        }));
    }
    return null;
};
/* harmony default export */ var Modals_UserSessionModal = (UserSessionModal);

;// CONCATENATED MODULE: ./components/Modals/ParentErrorModal/styles.js
var ParentErrorModal_styles_defaultExport = new String(".title.jsx-a675d99f324a0f2d{text-align:center;\nmargin:16px 0 8px 0;\nfont-size:1.25rem;\nfont-weight:600;\ncolor:#1a1a1a}\n.message.jsx-a675d99f324a0f2d{text-align:center;\nmargin:0 0 16px 0;\nfont-size:1rem;\ncolor:#6b7280;\nline-height:1.5}");
ParentErrorModal_styles_defaultExport.__hash = "a675d99f324a0f2d";
/* harmony default export */ var ParentErrorModal_styles = (ParentErrorModal_styles_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/ParentErrorModal/index.js








var ParentErrorModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)(ModalConfirm/* default */.Z, {
        showRejectButton: false,
        isOpen: isOpen,
        onConfirm: onClose,
        onCancel: onClose,
        buttonConfirmLabel: "Entendido",
        message: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                size: "large",
                style: {
                    color: colors/* iadProvitionalColors.error */.Du.error
                },
                icon: "md-alert-circle-outline"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: /*#__PURE__*/ "jsx-".concat(ParentErrorModal_styles.__hash) + " " + "title",
                children: "Padrino no v\xe1lido"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-".concat(ParentErrorModal_styles.__hash) + " " + "message",
                children: "El broker ya no es v\xe1lido como padrino, por favor, selecciona otro"
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: ParentErrorModal_styles.__hash,
                children: ParentErrorModal_styles
            })
        ]
    }));
};
ParentErrorModal.propTypes = {
    isOpen: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func.isRequired
};
/* harmony default export */ var Modals_ParentErrorModal = (ParentErrorModal);

;// CONCATENATED MODULE: ./components/Modals/ParentConfirmModal/styles.js
var ParentConfirmModal_styles_defaultExport = new String(".title.jsx-c4e54685f55052ff{text-align:center;\nmargin:16px 0 8px 0;\nfont-size:1.25rem;\nfont-weight:600;\ncolor:#1a1a1a}\n.message.jsx-c4e54685f55052ff{text-align:center;\nmargin:0 0 8px 0;\nfont-size:1rem;\ncolor:#374151;\nline-height:1.5}\n.submessage.jsx-c4e54685f55052ff{text-align:center;\nmargin:0 0 16px 0;\nfont-size:0.875rem;\ncolor:#dc2626;\nline-height:1.4;\nfont-style:italic}");
ParentConfirmModal_styles_defaultExport.__hash = "c4e54685f55052ff";
/* harmony default export */ var ParentConfirmModal_styles = (ParentConfirmModal_styles_defaultExport);

;// CONCATENATED MODULE: ./components/Modals/ParentConfirmModal/index.js


/* eslint-disable react/jsx-filename-extension */ 





var ParentConfirmModal = function(param) {
    var isOpen = param.isOpen, onConfirm = param.onConfirm, onCancel = param.onCancel, parentName = param.parentName, loading = param.loading;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)(ModalConfirm/* default */.Z, {
        // eslint-disable-next-line react/jsx-boolean-value
        showRejectButton: true,
        isOpen: isOpen,
        onConfirm: onConfirm,
        onCancel: onCancel,
        buttonConfirmLabel: "S\xed, elegir padrino",
        buttonRejectLabel: "Cancelar",
        loading: loading,
        message: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                size: "large",
                style: {
                    color: colors/* iadProvitionalColors.primary */.Du.primary
                },
                icon: "md-person-circle-outline"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: /*#__PURE__*/ "jsx-".concat(ParentConfirmModal_styles.__hash) + " " + "title",
                children: "Confirmar selecci\xf3n de padrino"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-".concat(ParentConfirmModal_styles.__hash) + " " + "message",
                children: [
                    "Vas a elegir a",
                    ' ',
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "jsx-".concat(ParentConfirmModal_styles.__hash),
                        children: parentName
                    }),
                    ' ',
                    "como tu padrino dentro de la red. \xbfQuieres continuar con esta opci\xf3n?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-".concat(ParentConfirmModal_styles.__hash) + " " + "submessage",
                children: "Esta decisi\xf3n es muy importante. La selecci\xf3n de padrino solo puede hacerse una vez, posteriormente si se quiere hacer un cambio, es necesaria la autorizaci\xf3n de la red."
            }),
            (0,jsx_runtime.jsx)(styled_jsx_style["default"], {
                id: ParentConfirmModal_styles.__hash,
                children: ParentConfirmModal_styles
            })
        ]
    }));
};
ParentConfirmModal.propTypes = {
    isOpen: (prop_types_default()).bool.isRequired,
    onConfirm: (prop_types_default()).func.isRequired,
    onCancel: (prop_types_default()).func.isRequired,
    parentName: (prop_types_default()).string,
    loading: (prop_types_default()).bool
};
ParentConfirmModal.defaultProps = {
    parentName: 'este asesor',
    loading: false
};
/* harmony default export */ var Modals_ParentConfirmModal = (ParentConfirmModal);

// EXTERNAL MODULE: ./components/Modals/PasswordAuditModal/index.js + 1 modules
var PasswordAuditModal = __webpack_require__(40089);
;// CONCATENATED MODULE: ./components/Modals/index.js















/***/ })

}]);